import { coverageRSForcedAtXYearsStates, extendedCoverageRSByRoofMaterialStateExclusions, extendedCoverageRSLimitsCW, extendedCoverageRSByRoofMaterialNonCWStatesList, extendedCoverageRSLimitsNonCW, noShowRoofSurfacesExtendedUnderXYearsStates } from '../roof-constants';
import { mapExpandedToSimpleRoofType } from './roof-material-mappings';
import { getTXRoofSurfacesExtended, getOKRoofSurfacesExtended } from './tx-roof-rules';
export function getRoofAgeLimit({ roofType, state, deductibleWindHail, roofAge }) {
    if (state === 'TX' && roofAge && deductibleWindHail) {
        return getTXRoofSurfacesExtended(roofAge, deductibleWindHail).roofAgeLimit;
    }
    if (state === 'OK' && roofAge && deductibleWindHail) {
        return getOKRoofSurfacesExtended(roofAge, deductibleWindHail).roofAgeLimit;
    }
    // states where coverageRSExtended is determined by roofAge only
    if (noShowRoofSurfacesExtendedUnderXYearsStates[state]) {
        return noShowRoofSurfacesExtendedUnderXYearsStates[state];
    }
    // use the simpler roof types
    const simpleRoofType = roofType?.length > 1 ? mapExpandedToSimpleRoofType(roofType) : roofType;
    // Check eligibility for extended coverage based on state and roof type
    const isStateEligibleForExtendedCoverage = !extendedCoverageRSByRoofMaterialStateExclusions.includes(state);
    const hasRoofTypeSpecificLimits = Object.keys(extendedCoverageRSLimitsCW).includes(simpleRoofType);
    // Default state limits if not eligible for extended coverage
    if ((!isStateEligibleForExtendedCoverage || !hasRoofTypeSpecificLimits) &&
        coverageRSForcedAtXYearsStates[state]) {
        return coverageRSForcedAtXYearsStates[state] || 15;
    }
    // Apply specific limits based on CW or non-CW state
    const isNonCWState = extendedCoverageRSByRoofMaterialNonCWStatesList.includes(state);
    if (isNonCWState) {
        return extendedCoverageRSLimitsNonCW[simpleRoofType] || 10;
    }
    return extendedCoverageRSLimitsCW[simpleRoofType] || 15;
}
//# sourceMappingURL=get-roof-age-limit.js.map